// @ts-ignore

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import {
    DisplayProps,
    IndividualTabPropsQuote
} from "@/components/wpl/tab-group/src";
import { wacToken } from "@/libraries/design/foundations";
import { BGProps, StyledBackground } from "@/libraries/wpl/foundations/src";
import TabsQuote from "@/patterns/wpl/tabs-quote/src";

import {
    deliverValueFastTabSectionVideo,
    devopsTabSectionVideo,
    empowerAllTeamsTabSectionVideo
} from "../localized-images";

const tabsWrapper = css({
    // Note: Existing tech debt, should be fixed GWP-4458
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".jira-service-management-tabs": {
        "padding": "80px 0 32px",
        // Note: Existing tech debt, should be fixed GWP-4458
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".tabquote-tab-group-div": {
            "paddingBlockStart": "38px",
            // Note: Existing tech debt, should be fixed GWP-4458
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".tab-group-inner": {
                gap: "8px",
                // Note: Existing tech debt, should be fixed GWP-4458
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                button: {
                    "padding": "4px 30px",
                    "border": "1px solid transparent",
                    "transition": "all 0.25s",
                    "fontWeight": 300,
                    "letterSpacing": "1px",
                    "&:hover": {
                        borderStyle: "solid",
                        borderWidth: "1px",
                        borderColor: wacToken("color.neutral.dark900")
                    },
                    "&:focus-visible": {
                        outline: "revert"
                    },
                    [media.below.md]: {
                        fontSize: "1.25rem"
                    }
                },
                // Note: Existing tech debt, should be fixed GWP-4458
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                [`[aria-selected="true"]`]: {
                    "&:hover": {
                        borderColor: "transparent"
                    }
                }
            },
            // Note: Existing tech debt, should be fixed GWP-4458
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".select-container": {
                // Note: Existing tech debt, should be fixed GWP-4458
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                ".row-layout": {
                    padding: 0
                }
            },
            // Note: Existing tech debt, should be fixed GWP-4458
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".select-container-inner": {
                minWidth: "300px",
                maxWidth: "388px",
                width: "100%",
                margin: "auto"
            },
            // Note: Existing tech debt, should be fixed GWP-4458
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "#tabs-section": {
                "border": "none",
                "fontSize": "1rem",
                "lineHeight": "40px",
                "padding": "0 15px",
                "width": "100%",
                "&:focus-visible": {
                    outline: "revert"
                }
            },
            // Note: Existing tech debt, should be fixed GWP-4458
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".tab-panels": {
                "padding": "32px 0",
                // Note: Existing tech debt, should be fixed GWP-4458
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                ".row-layout": {
                    "alignItems": "start",
                    [media.below.sm]: {
                        "display": "flex",
                        "flexDirection": "column-reverse",
                        // Note: Existing tech debt, should be fixed GWP-4458
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                        ".content-block": {
                            padding: 0
                        }
                    },
                    [media.only.sm]: {
                        // Note: Existing tech debt, should be fixed GWP-4458
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                        video: {
                            marginBlockStart: "10px"
                        }
                    },
                    [media.above.sm]: {
                        // Note: Existing tech debt, should be fixed GWP-4458
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                        video: {
                            height: "460px"
                        }
                    },
                    // Note: Existing tech debt, should be fixed GWP-4458
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    "div:nth-of-type(1)": {
                        // Note: Existing tech debt, should be fixed GWP-4458
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                        "div:nth-of-type(2)": {
                            borderRadius: "0px 150px 150px 0px",
                            [media.below.md]: {
                                display: "none"
                            }
                        }
                    }
                }
            }
        },
        // Note: Existing tech debt, should be fixed GWP-4458
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& .tab-group .text-section": {
            "display": "grid",
            "gridTemplateColumns": "48px 1fr",
            "gridTemplateAreas": '"icon title" ". body "',
            "gridColumnGap": "1rem",
            "alignItems": "start",
            "letterSpacing": "0.3px",
            "gap": "8px",
            // Note: Existing tech debt, should be fixed GWP-4458
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "> h3": {
                gridArea: "title",
                paddingBlockStart: "4px",
                paddingBlockEnd: `${token("space.150")}`,
                fontWeight: 400
            },
            // Note: Existing tech debt, should be fixed GWP-4458
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "> .contentBlock-body": {
                gridArea: "body",
                paddingInlineEnd: "24px",
                marginBlockStart: "-12px"
            },
            // Note: Existing tech debt, should be fixed GWP-4458
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "> .icon": {
                gridArea: "icon",
                margin: 0,
                backgroundColor: wacToken("color.neutral.light0"),
                borderRadius: "50%",
                width: "42px",
                height: "42px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // Note: Existing tech debt, should be fixed GWP-4458
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                svg: {
                    fill: wacToken("color.primary.blue"),
                    width: "24px",
                    height: "24px"
                }
            }
        },
        // Note: Existing tech debt, should be fixed GWP-4458
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "h2": {
            fontSize: "2.25rem",
            margin: 0,
            fontWeight: 400
        },
        // Note: Existing tech debt, should be fixed GWP-4458
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "h3": {
            fontSize: "1.5rem",
            margin: 0
        },
        // Note: Existing tech debt, should be fixed GWP-4458
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "p": {
            fontFamily: wacToken("font.charlie.display"),
            fontSize: "1rem",
            lineHeight: 1.4,
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale"
        },
        [media.below.sm]: {
            // Note: Existing tech debt, should be fixed GWP-4458
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "h2, h3": {
                fontSize: "1.25rem"
            }
        }
    }
});

const TabsSection = () => {
    const intl = useIntl();

    const accelerateDevAndOpsLocalizedMedia: DisplayProps = {
        videoProps: {
            videoLink: devopsTabSectionVideo
        }
    };

    const empowerAllServiceTeamsLocalizedMedia: DisplayProps = {
        videoProps: {
            videoLink: empowerAllTeamsTabSectionVideo
        }
    };

    const deliverValueFastLocalizedMedia: DisplayProps = {
        videoProps: {
            videoLink: deliverValueFastTabSectionVideo
        }
    };

    const tabs: IndividualTabPropsQuote[] = [
        {
            textLabel: "Accelerate Dev and Ops",
            id: "tab-accelerate-dev-and-ops",
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsHeader.plan",
                defaultMessage: "Accelerate Dev and Ops"
            }),
            iconName: "accelerator",
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsBody.plan",
                defaultMessage:
                    "Connect Dev and Ops teams on a single AI-powered platform to supercharge collaboration across changes, incidents, and requests - all while managing risk."
            }),
            display: accelerateDevAndOpsLocalizedMedia
        },
        {
            textLabel: "Empower all service teams",
            id: "tab-empower-all-service-teams",
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsHeader.track",
                defaultMessage: "Empower all service teams"
            }),
            iconName: "team",
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsBody.track",
                defaultMessage:
                    "Service management isn’t just for IT. Make it easy for teams across the business - from HR to Legal to Facilities - to streamline requests, centralize knowledge, and work the way they want."
            }),
            display: empowerAllServiceTeamsLocalizedMedia
        },
        {
            textLabel: "Deliver value fast",
            id: "tab-deliver-value-fast",
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsHeader.release",
                defaultMessage: "Deliver value fast"
            }),
            iconName: "lightning",
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsBody.release",
                defaultMessage:
                    "Tune Jira Service Management to your unique requirements - without the complexity of traditional ITSM solutions. Get started fast and and scale as you go, with features like customizable templates, dynamic forms, and AI-powered project configuration."
            }),
            display: deliverValueFastLocalizedMedia
        }
    ];

    const backgroundProperties: BGProps = {
        textColor: wacToken("color.neutral.light0"),
        gradientDirection: "180",
        bgColor: wacToken("color.extended.blue800"),
        bgColor2: wacToken("color.extended.purple800")
    };
    return (
        <section css={tabsWrapper}>
            <StyledBackground {...backgroundProperties}>
                <TabsQuote
                    id="tabs-section"
                    label="Tabs"
                    headerText={intl.formatMessage({
                        id: "JiraServiceManagementPageTemplate.tabsHeader",
                        defaultMessage: "High-velocity service management"
                    })}
                    bodyText=""
                    tabs={tabs}
                    colors={{
                        defaultBG: wacToken("color.neutral.light0"),
                        defaultText: wacToken("color.neutral.light700"),
                        activeBG: wacToken("color.extended.blue100"),
                        activeText: wacToken("color.extended.blue1000"),
                        hoverBG: wacToken("color.neutral.light0"),
                        hoverText: wacToken("color.neutral.light700")
                    }}
                    className="jira-service-management-tabs"
                />
            </StyledBackground>
        </section>
    );
};

export default TabsSection;
